<ng-content></ng-content>
<sui-icon *ngIf="isValid" name="체크"></sui-icon>
